<div class="search-container">
  <div class="search-wrapper">
    <div class="input-wrapper" [class.active]="query?.length">
      @if (showBackButton) {
        <button class="clear-button left" (click)="goBack()"><i class="pi pi-arrow-left"></i></button>
      }
      <input type="text" placeholder="¿Qué deseas buscar?" [(ngModel)]="query"  (keydown.enter)="searchQuery()" (click)="showOverlay()" #input />
      @if (query?.length) {
        <button class="clear-button right" (click)="clearQuery()"><i class="icon-cancel-fill"></i></button>
      }
    </div>
    <button class="search-button" [disabled]="!query?.length" (click)="searchQuery()"><i class="icon-search icon"></i></button>
  </div>
  @if (isOverlayVisible) {
    <div class="search-overlay" #overlay>
      @if (searchHistory?.length) {
        <div class="search-history-container">
          <div class="search-history-headers">
            <span class="title">Historial de búsqueda</span>
            <span class="delete-history" (click)="deleteSearchHistory()">Borrar historial</span>
          </div>
          <div class="search-history-entries">
            @for (entry of searchHistory; track $index) {
              <div class="entry" (click)="searchQuery(entry)">
                <i class="icon-search"></i>
                <span class="entry-name">{{ entry }}</span>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="empty-search-history-container">
          <img src="/assets/illustrations/empty-search.svg" alt="Ilustración de historial de búsqueda vacío." />
          <p class="message">Aún no tienes búsquedas recientes</p>
          <div class="disclaimer">
            <p>Te ayudamos a encontrar eso que tanto deseas para tu hogar.</p>
            <p>Comienza buscando algún producto.</p>
          </div>
        </div>
      }
    </div>
  }
</div>
